// Libs
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import { useSnackbar } from 'notistack';

// Services
import { DELETE, ePUT } from "../../../services/Bridge";

// Style
import style from './style.module.css';

const Message = ({ message, webText, newMessages }) => {

  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const [opened, setOpened] = useState(false);
  const [messageSeen, setMessageSeen] = useState(message.isSeen);

  const date = new Date();
  date.setTime(message.dateAdded);

  const handleDelete = async () => {

    try {
      const response = await DELETE({
        path: "demand",
        params: { id: message.id }
      });

      enqueueSnackbar("Správa vymazaná", {
        variant: "success",
        autoHideDuration: 3000,
        onEntered: () => {
          newMessages(response.messages);
          setOpened(false);
          setMessageSeen(false);
        }
      });

    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
        autoHideDuration: 5000,
      });
    };
  };

  const handleOpen = async () => {

    if (!(messageSeen || opened)) {
      setOpened(prevState => !prevState);
      try {
        await ePUT({ path: "saw-message", data: message });
        setMessageSeen(true);

      } catch (error) {
        enqueueSnackbar(error, {
          variant: "error",
          autoHideDuration: 5000,
        });
      };

    } else setOpened(prevState => !prevState);
  };

  return (
    <div
      className={`
        ${style.message}
        ${!messageSeen ? style.notSeen : null}
        ${opened ? style.opened : null}
      `}
    >

      <p className={style.date}>{date.getDate()}.{date.getMonth()}.{date.getFullYear()}</p>

      <p className={style.fullName}>{message.fullName}</p>

      <p className={style.email}>{message.email}</p>

      <p className={style.mobile}>{message.mobileNumber}</p>

      <Tooltip
        title={webText.showDemand}
        placement="top"
        color="main"
        disableInteractive
        arrow
      >
        <button className={style.showMsgBtn} onClick={handleOpen} >
          <svg viewBox="0 0 576 512">
            <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/>
          </svg>
        </button>
      </Tooltip>

      <Tooltip
        title={webText.openAdvertisement}
        placement="top"
        color="main"
        disableInteractive
        arrow
      >
        <button className={style.openLinkBtn} onClick={() => navigate(`/item/${message.item}`)}>
          <svg viewBox="0 0 512 512">
            <path d="M307 34.8c-11.5 5.1-19 16.6-19 29.2l0 64-112 0C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96l96 0 0 64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"/>
          </svg>
        </button>
      </Tooltip>

      <Tooltip
        title={webText.deleteDemand}
        placement="top"
        color="main"
        disableInteractive
        arrow
      >
        <button className={style.deleteMsgBtn} onClick={handleDelete}>
          <svg viewBox="0 0 448 512">
            <path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
          </svg>
        </button>
      </Tooltip>

      <h2 className={style.messageTitle}>{webText.demandMessageInMessage}:</h2>

      <p className={style.messageText}>{message.message}</p>

    </div>
  );
};

export default Message;